import contactInfo_en from './contact-info_en.json'
import overviewWidget_en from './overview-widget_en.json'

const ebd_resources = {
  en: {
    ...contactInfo_en,
    ...overviewWidget_en,
  },
}

export default ebd_resources
